import React from 'react';
import FaExternalLink from "react-icons/lib/fa/external-link";


export default class MenuLink extends React.Component {
  render() {
    return (
      <div className="closed-menu link">
        <h3>
          <a href={this.props.url} target="_blank" rel="noopener noreferrer">
          {this.props.label}</a> <FaExternalLink />
        </h3>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/MenuLink.js